import { isStandaloneDisplay } from '@/domains/install'

/* a url that only arrives after an await is treated as a popup by ios and
 * blocked, so the tab is opened on the click itself and handed over. an
 * installed app has no tab to come back from, so it navigates in place. */
export function openBlankTab(): Window | null {
  return isStandaloneDisplay() ? null : window.open('', '_blank')
}

export function navigateTab(url: string, tab?: Window | null): void {
  if (tab) {
    tab.location.href = url
    return
  }
  if (isStandaloneDisplay()) {
    window.location.assign(url)
    return
  }
  window.open(url, '_blank', 'noopener')
}
